import React, { useState } from 'react';
import LinkButton from '../../../../Components/Button/LinkButton';
import { Theme } from '../../../../Enums/Theme.enum';
import Text from '../../../../Components/Base/Text/Text';
import { joinClasses } from '../../../../Utils/className.util';
import WorkplaceOrWorkplaceMemberSelect, {
	WorkplaceOrWorkplaceMemberSelectValue,
} from '../../../Base/Components/WorkplaceOrWorkplaceMemberSelect/WorkplaceOrWorkplaceMemberSelect';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import CaseForwardConfirmModal from '../CaseForwardConfirn/CaseForwardConfirmModal';
import NetteApiClient from '../../../../Services/NetteApiClient';
import { useAppContext } from '../../../../Services/AppContext';
// @ts-ignore
import styles from './CaseForwarder.module.scss';

interface Props {
	caseId: string;
	className?: string;
	isToggled?: boolean;
	onSuccess?: () => void;
	onClose?: () => void;
}

const CaseForwarder: React.FC<Props> = ({
	caseId,
	className,
	isToggled = false,
	onSuccess,
	onClose,
}) => {
	const [isChangeAllowed, setIsChangeAllowed] = useState(false);
	const [isChanging, setIsChanging] = useState(isToggled);
	const [isOpened, setIsOpened] = useState(false);
	const [workplaceMemberId, setWorkplaceMemberId] = useState();
	const [workplaceId, setWorkplaceId] = useState();
	const [label, setLabel] = useState<string>('');
	const { redirectCaseList } = useAppContext();

	const handleToggleChange = () => {
		setIsChanging(true);
	};

	const handleSelect = (value: SelectValue) => {
		const { item } = value as WorkplaceOrWorkplaceMemberSelectValue;

		if (item) {
			setIsChangeAllowed(true);
		}

		if (item.user) {
			const label =
				item.user.profile.fullName +
				' (' +
				(item.workplace.rootWorkplace &&
					item.workplace.rootWorkplace.doctorDisplayName) +
				',' +
				item.workplace.doctorDisplayName +
				')';
			setWorkplaceMemberId(item.id);
			setLabel(label);
			setWorkplaceId(undefined);
		}

		if (item.doctorDisplayName) {
			setWorkplaceId(item.id);
			setLabel(item.doctorDisplayName);
			setWorkplaceMemberId(undefined);
		}
	};

	const handleAfterForward = () => {
		setIsOpened(false);
		if (onSuccess) {
			setIsChanging(false);
			onSuccess();
		} else {
			NetteApiClient.get(redirectCaseList);
			onClose?.();
		}
	};

	const handleChange = () => {
		if (isChangeAllowed) {
			setIsOpened(true);
		}
	};

	return (
		<>
			<div className={joinClasses([styles.wrapper, className])}>
				{!isChanging ? (
					<LinkButton
						title={'component.caseForwarder.passTheCaseToOtherMedicOrWorkplace'}
						theme={Theme.BLUE}
						onClick={handleToggleChange}
						className={styles.toggleButton}
					/>
				) : (
					<div className={joinClasses(['case-forwarder', styles.inputGroup])}>
						<WorkplaceOrWorkplaceMemberSelect
							onChange={handleSelect}
							placeholder={
								'component.caseForwarder.startTypingSurnameOfMedicOrNameOfWorkplace'
							}
							filter={{
								searchWorkplaceNormalOnly: true,
							}}
						/>
						<div
							className={joinClasses([
								styles.button,
								isChangeAllowed ? styles.allowed : undefined,
							])}
							onClick={handleChange}>
							<Text tx={'base.change'} inline={true} firstUpper={true} />
						</div>
					</div>
				)}
			</div>
			{isOpened && (
				<CaseForwardConfirmModal
					caseId={caseId}
					label={label}
					workplaceId={workplaceId}
					workplaceMemberId={workplaceMemberId}
					opened={isOpened}
					onClose={() => setIsOpened(false)}
					onCaseForward={handleAfterForward}
				/>
			)}
		</>
	);
};

export default CaseForwarder;
